import { Directive, Input, ElementRef, Inject, ChangeDetectorRef, SimpleChange, Optional } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
interface ICambio {
  focus: SimpleChange
}
@Directive({
  selector: '[focus]'
})
export class FocusDirective {
  @Input()
  focus: boolean;

  constructor(@Inject(ElementRef) private eRef: ElementRef) {
  }

  ngOnChanges(value: ICambio) {
    if (value.focus.currentValue) {
      setTimeout(() => {
        const elemento: HTMLElement = this.eRef.nativeElement;
        elemento.focus();
      }, 20);
    }
  }
}
